module.exports = __webpack_public_path__ + "img/bank_accounts_border.039b6966.svg";